const handleScroll = (href: string) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200 pt-14 md:pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                樱
              </span>
              <span className="text-lg font-semibold text-background-50 font-heading">
                樱花漫画
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              汇聚日漫、韩漫、国漫的综合性漫画阅读平台。
              提供漫画下载离线阅读、免费全集收藏追更，
              让每一位漫画爱好者都能找到属于自己的漫画世界。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">快速导航</h3>
            <ul className="space-y-2">
              {[
                { label: '热门精选', href: '#carousel' },
                { label: '平台特色', href: '#features' },
                { label: '热门连载', href: '#cards' },
                { label: '分类索引', href: '#index' },
                { label: '排行榜', href: '#ranking' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleScroll(item.href);
                    }}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">帮助中心</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#faq"
                  onClick={(e) => {
                    e.preventDefault();
                    handleScroll('#faq');
                  }}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  常见问题
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    handleScroll('#contact');
                  }}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  投稿咨询
                </a>
              </li>
              <li>
                <a
                  href="#app"
                  onClick={(e) => {
                    e.preventDefault();
                    handleScroll('#app');
                  }}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  APP下载
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500">
              更多合作伙伴即将加入
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2020-2026 樱花漫画 yinghuamanhua.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => { e.preventDefault(); handleScroll('#hero'); }} className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">首页</a>
            <a href="#about" onClick={(e) => { e.preventDefault(); handleScroll('#about'); }} className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">关于我们</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); handleScroll('#contact'); }} className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}